import { useCallback, useState } from "react";

interface DialogState<T> {
	open: boolean;
	data: T | null;
}

interface UseDialogStateReturn<T> {
	dialogState: DialogState<T>;
	openDialog: (data: T) => void;
	closeDialog: () => void;
}

export const useDialogState = <T>(): UseDialogStateReturn<T> => {
	const [dialogState, setDialogState] = useState<DialogState<T>>({
		open: false,
		data: null,
	});

	const openDialog = useCallback((data: T) => {
		setDialogState({ open: true, data });
	}, []);

	const closeDialog = useCallback(() => {
		setDialogState({ open: false, data: null });
	}, []);

	return {
		dialogState,
		openDialog,
		closeDialog,
	};
};
